import { CharacterClassIcon } from 'app/frontend/base/components'
import CharacterClass, {
  characterClasses,
} from 'app/frontend/types/custom/CharacterClass'
import StatTable from './StatTable'

const CountByClass = ({ className }: { className?: string }) => {
  return (
    <StatTable<CharacterClass>
      className={className}
      title='Class'
      subject={characterClasses.reduce((acc, characterClass) => {
        acc[characterClass] = characterClass
        return acc
      }, {} as Record<CharacterClass, CharacterClass>)}
      memberFilterFn={(member, classes) =>
        classes.includes(member.characterReference.characterClass)
      }
      valueFn={(_, characterClass) => (
        <span className='flex items-center gap-1.5'>
          <CharacterClassIcon characterClass={characterClass} size='small' />
          {characterClass}
        </span>
      )}
    />
  )
}

export default CountByClass
